import React from "react";
import { Pagination } from "@mui/material";

interface PaginationProps {
  page: number;
  totalResults: number;

  resultsPerPage: number;

  handlePageChange: (event: React.ChangeEvent<unknown>, newPage: number) => void;
}
export const PaginationComponent = (props: PaginationProps) => {
  const { page, totalResults, resultsPerPage, handlePageChange } = props;
  return (
    <Pagination
      siblingCount={0}
      page={page}
      count={Math.ceil(totalResults / resultsPerPage)}
      onChange={handlePageChange}
      size="large"
    />
  );
};
